var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M144,170.3L272.6,96c4.4-2.6,9.9-2.6,14.3,0l81,46.8c8.1,4.7,9.6,15.8,3,22.5l-27.5,27.6c-4.6,4.6-11.7,5.5-17.3,2.3 l-39.1-22.6c-4.5-2.6-10.1-2.6-14.6,0l-135.6,79.1l0-69C136.9,177.5,139.6,172.8,144,170.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.1,369L286.8,416c-4.4,2.6-9.9,2.6-14.3,0l-128.6-74.3c-4.4-2.6-7.2-7.3-7.2-12.4v-62.6l66.3-38.4v62.8 c0,5.1,2.7,9.8,7.2,12.4l62.3,36c4.4,2.6,9.9,2.6,14.3,0l39.4-22.8c5.6-3.2,12.7-2.3,17.3,2.3l27.6,27.6 C377.7,353.2,376.3,364.3,368.1,369z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrust);
export default __webpack_public_path__ + "static/media/crust.0016271e6b70ecad1b3b93e2620993d3.svg";
export { ForwardRef as ReactComponent };